import React, { useState } from 'react';
import ModalBase from './Modals/ModalBase';

const RegisterButton = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <button
        onClick={openModal}
        className='register btn primary'>
        Registro fundación
      </button>

      <ModalBase
        isOpen={isModalOpen}
        closeModal={closeModal}>
        <div className='register-content'>
          <h2>Registro</h2>
          <p>
            Para registrarse como fundación y ser visible en la página de
            fundaciones del Centro Comercial Titán Plaza, primero es
            necesario hacer el registro con nuestros aliados estratégicos
            Nibi. Da click en el siguiente botón y regístrate como
            organización sin ánimo de lucro para comenzar tu proceso de
            validación
          </p>
          <a
            href='https://nibi.com.co/register1'
            className='btn primary'>
            Registrate como fundación
          </a>
        </div>
      </ModalBase>
    </>
  );
};

export default RegisterButton;
